<template>
  <div class="margin-bottom-m margin-top-s">
    <div class="error-color large">
      Sorry, this item is currently unavailable.
    </div>

    <div
      v-if="similarItemsUrl"
      :class="marginTopClass"
    >
      <a
        :href="similarItemsUrl"
        class="button emphasis expanded"
      >Shop Similar Items</a>
    </div>

    <div
      v-if="brandUrl"
      class="margin-top-xs"
    >
      <a
        :href="brandUrl"
        class="button secondary expanded"
        v-html="`Shop All ${brandDisplayName}`"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useBrand } from '@composables/useBrand';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import useUnavailableProduct from '@composables/useUnavailableProduct';

const { similarItemsUrl } = useUnavailableProduct();

const {
  brandDisplayName,
  brandUrl,
} = useCommonProductGetters();

const { isMcom } = useBrand();
const marginTopClass = computed(() => (isMcom ? 'margin-top-m' : 'margin-top-s'));
</script>
